import Vue from 'vue';
import PulseDots from '@/core/components/pulse-dots.vue';
import { nanoid } from 'nanoid';

const instances = {};

class Loading {
    el

    PulseDotsClass;
    PulseDotsComponent;

    prevIsLoading = false;

    constructor(el) {
        this.PulseDotsClass = Vue.extend(PulseDots);

        this.el = el;
    }

    setLoadingOverlay() {
        if (this.prevIsLoading) {
            return;
        }

        this.el.classList.add('l-ss-c-loading-overlay');

        this.PulseDotsComponent = new this.PulseDotsClass();

        const pulseDotsEl = this.PulseDotsComponent.$mount().$el;

        this.el.appendChild(pulseDotsEl);

        this.prevIsLoading = true;
    }

    removeLoadingOverlay() {
        if (this.el && this.el.classList) {
            this.el.classList.remove('l-ss-c-loading-overlay');
        }

        if (this.PulseDotsComponent) {
            this.PulseDotsComponent.$destroy();

            if (this.PulseDotsComponent.$el) {
                this.PulseDotsComponent.$el.remove();
            }
        }

        this.prevIsLoading = false;
    }

    destroy() {
        this.removeLoadingOverlay();
        this.PulseDotsClass = null;
        this.PulseDotsComponent = null;
    }
}

export default {
    bind(el) {
        const id = nanoid();

        el.setAttribute('data-loading-id', id);
        instances[id] = new Loading(el);
    },
    update(el, binding) {
        const isLoading = binding.value;
        const loadingInstance = instances[el.dataset.loadingId];

        if (isLoading) {
            loadingInstance.setLoadingOverlay();
        } else {
            loadingInstance.removeLoadingOverlay();
        }
    },
    unbind(el) {
        const id = el.dataset.loadingId;
        const loadingInstance = instances[id];

        loadingInstance.destroy();

        delete instances[id];
    },
};
